import { render, staticRenderFns } from "./NuevaRuta.vue?vue&type=template&id=85d35b7e&scoped=true&"
import script from "./NuevaRuta.vue?vue&type=script&lang=ts&"
export * from "./NuevaRuta.vue?vue&type=script&lang=ts&"
import style0 from "./NuevaRuta.vue?vue&type=style&index=0&id=85d35b7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d35b7e",
  null
  
)

export default component.exports